import React from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

import slideLeft from 'assets/images/svg/icon-slide-left.svg'
import slideRight from 'assets/images/svg/icon-slide-right.svg'

const CarouselMulti = ({
  deviceType,
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
}) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  }
  const styleImage = {
    width: '100%',
  }

  const CustomLeftArrow = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        style={{
          position: 'absolute',
          background: 'transparent',
          border: 'none',
          left: '40px',
          cursor: 'pointer',
        }}
      >
        <img src={slideLeft} alt='slide left' style={styleImage}loading="lazy" />
      </button>
    )
  }

  const CustomRightArrow = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        style={{
          position: 'absolute',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          right: '40px',
        }}
      >
        <img src={slideRight} alt='slide right' style={styleImage}loading="lazy" />
      </button>
    )
  }

  return (
    <Carousel
      showDots={false}
      responsive={responsive}
      ssr={true} // means to render carousel on server-side.
      infinite={true}
      // autoPlay={true}
      // autoPlaySpeed={1000}
      keyBoardControl={true}
      customTransition='all .5'
      transitionDuration={1000}
      containerClass='carousel-container'
      removeArrowOnDeviceType={['tablet', 'mobile']}
      deviceType={deviceType}
      dotListClass='custom-dot-list-style'
      itemClass='carousel-item-padding-40-px'
      customRightArrow={<CustomRightArrow />}
      customLeftArrow={<CustomLeftArrow />}
    >
      {image1 && <img src={image1} alt='carousel' style={styleImage}loading="lazy" />}
      {image2 && <img src={image2} alt='carousel' style={styleImage}loading="lazy" />}
      {image3 && <img src={image3} alt='carousel' style={styleImage}loading="lazy" />}
      {image4 && <img src={image4} alt='carousel' style={styleImage} loading="lazy"/>}
      {image5 && <img src={image5} alt='carousel' style={styleImage} loading="lazy"/>}
      {image6 && <img src={image6} alt='carousel' style={styleImage} loading="lazy"/>}
      {image7 && <img src={image7} alt='carousel' style={styleImage} loading="lazy"/>}
      {image8 && <img src={image8} alt='carousel' style={styleImage}loading="lazy" />}
    </Carousel>
  )
}

export default CarouselMulti
